<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New File</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  show-size
                  label="Enter User E-mail"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text :loading="loading" @click="create">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Axios } from '../../services';

export default {
  name: 'UserCreationDialog',
  data: () => ({
    dialog: false,
    loading: false,
    email: ''
  }),
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    create() {
      if (!this.email) return;

      return Axios.Api.post(`/v1/users`, {
        email: this.email
      })
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.dialog = false;
          this.$emit('onCreate', res);
          return res;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
